module.exports = __webpack_public_path__ + "img/video-solid.18ab9cde.svg";